import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"
import { useEffect, useRef } from "react"


import { useMediaQuery } from "@/hooks/useMediaQuery.ts"
import { darkTheme } from "@/styles/mixins.ts"

import type { TerminalModel } from "@/routes/tasks/TaskViewScene/TerminalModel.ts"

export const TaskPreviewTerminal = observer((props: {
  model: TerminalModel
  backgroundColor?: string
}) => {
  const el = useRef<HTMLDivElement>(null)

  const useDarkTheme = useMediaQuery(darkTheme)

  useEffect(() => {
    if (el.current) {
      void props.model.init(el.current, useDarkTheme, props.backgroundColor)
    }
    return () => props.model.terminate()
  }, [props.model, useDarkTheme, props.backgroundColor])

  return <TerminalContainer ref={el} />
})

const TerminalContainer = styled.div`
  flex: 1 1 auto;
  align-self: stretch;
  overflow: hidden;
  min-height: 0;

  .xterm, .xterm-viewport {
    outline: none;
  }
`
